var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "itp-section-padded", style: _vm.paddingStyles },
    [
      _vm.schema.blocks.length >= 2
        ? _c("div", { staticClass: "itp text-center container" }, [
            _c(
              "div",
              {
                staticClass: "itp__blocks itp__static",
                style: _vm.columnStyles
              },
              _vm._l(_vm.schema.blocks, function(block) {
                return block.settings.itp_logo
                  ? _c(
                      block.settings.itp_url ? "a" : "div",
                      {
                        key: block.id,
                        tag: "component",
                        staticClass: "itp__itp",
                        attrs: {
                          href: block.settings.itp_url,
                          "aria-label": block.settings.link_aria_label,
                          target: block.settings.itp_link_target || "_self"
                        }
                      },
                      [
                        _c("picture", { staticClass: "itp__img-wrap" }, [
                          _c("source", {
                            attrs: {
                              srcset: block.settings.itp_logo,
                              media: "(min-width: 992px)"
                            }
                          }),
                          _c("source", {
                            attrs: {
                              srcset: block.settings.itp_logo,
                              media: "(min-width: 768px)"
                            }
                          }),
                          _c("img", {
                            staticClass: "itp__img",
                            attrs: {
                              src: _vm.imageSize(
                                block.settings.itp_logo,
                                "600x"
                              ),
                              alt: block.itp_logo_alt
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e()
              }),
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }